import React, { useEffect, useState } from 'react'
import useOnScreen from './useOnScreen'

/**
 * Hook, triggering callbacks when element enter or leaves viewport
 */
export default function useOnScreenCallbacks(onIn: () => void, onOut: () => void, ref: React.RefObject<Element | null>, rootMargin = '0px') {
  const [wasIntersecting, setWasIntersecting] = useState(false)
  const isIntersecting = useOnScreen(ref, rootMargin)

  useEffect(() => {
    if (isIntersecting && !wasIntersecting) {
      onIn()
      setWasIntersecting(true)
    }
    if (!isIntersecting && wasIntersecting) {
      onOut()
      setWasIntersecting(false)
    }
  }, [onIn, onOut, wasIntersecting, isIntersecting, setWasIntersecting])
}
